export default {"src":"/_next/static/media/americanexpress.0e231f1c.svg","height":24,"width":34,"blurWidth":0,"blurHeight":0};